let maleJsonData = [];
let femaleJsonData = [];
async function fetchSheetData(sheetName) {
  const url = `https://opensheet.elk.sh/1mGkVP_KHGcK8MI2iZ57npptZtcWhleZMfq-XLyGBGcc/${sheetName}`;

  try {
    const res = await fetch(url);
    const data = await res.json();
    if (sheetName === "Male") {
      maleJsonData = data;
    } else if (sheetName === "Female") {
      femaleJsonData = data;
    }
    return data;
  } catch (err) {
    console.error(`Failed to fetch ${sheetName} data:`, err);
    return [];
  }
}

async function loadSheets() {
  fetchSheetData("Male"), fetchSheetData("Female");
}

loadSheets();

let dataRisePreference = [];
let dataFitPreference = [];
let dataFootwear = [];
let dataStretchPreference = [];
let dataStylePersona = [];
let displayResult = "";
let isFemale = false;
let fitInputFitPreference = "Loose";
let selectedTags = "male";
let gender = "men";
const nameInput = document.getElementById("nameInput");
const startButton = document.getElementById("startButton");
const buttonOverlay = document.getElementById("buttonOverlay");
const errorMessage = document.querySelector(".errorinput");

nameInput.addEventListener("input", function () {
  if (this.value.trim()) {
    startButton.disabled = false;
    buttonOverlay.style.display = "none";
    errorMessage.style.display = "none";
  } else {
    startButton.disabled = true;
    buttonOverlay.style.display = "block";
  }
});

buttonOverlay.addEventListener("click", function () {
  errorMessage.style.display = "block";
});
startButton.addEventListener("click", function () {
  if (!this.disabled) {
    errorMessage.style.display = "none !important";
    startQuiz();
  }
});
function startQuiz() {
  isFemale = document.getElementById("genderToggle").checked;
  selectedTags = isFemale ? "female" : "male";
  gender = isFemale ? "women" : "men";
  document.getElementById("fitfindrstart").style.display = "none";
  document.getElementById("forwomenquestion").style.display = "none";
  document.getElementById("formenquestion").style.display = "none";
  if (isFemale) {
    document.getElementById("forwomenquestion").style.display = "block";
    showScreenfemale(1);
  } else {
    document.getElementById("formenquestion").style.display = "block";
    showScreenmale(1);
  }
  const userName = nameInput.value
    .trim()
    .replace(/\b\w/g, (char) => char.toUpperCase());

  const usernameElements = document.getElementsByClassName("username");
  for (let i = 0; i < usernameElements.length; i++) {
    usernameElements[i].textContent = userName;
  }
}
function selectRisePreference(inputRisePreference) {
  setTimeout(() => {
    dataRisePreference = femaleJsonData.filter(
      (item) => item["Rise Preference"] === inputRisePreference
    );
    if (isFemale) {
      selectFitPreference("Comfy");
    } else {
      selectFitPreference("Loose");
    }
  }, 500);
}

function selectFitPreference(inputFitPreference) {
  fitInputFitPreference = inputFitPreference;
  if (isFemale) {
    if (
      fitInputFitPreference == "Fitted" ||
      fitInputFitPreference == "Second Skin"
    ) {
      document
        .querySelectorAll(".strechresult-display-message")
        .forEach((message) => {
          message.style.display = "block";
        });
    } else {
      document
        .querySelectorAll(".strechresult-display-message")
        .forEach((message) => {
          message.style.display = "none";
        });
    }
    dataFitPreference = dataRisePreference.filter(
      (item) => item["Fit Preference"] === inputFitPreference
    );
  } else {
    setTimeout(() => {
      if (
        fitInputFitPreference == "Fitted" ||
        fitInputFitPreference == "Second Skin"
      ) {
        document
          .querySelectorAll(".strechresult-display-message")
          .forEach((message) => {
            message.style.display = "block";
          });
      } else {
        document
          .querySelectorAll(".strechresult-display-message")
          .forEach((message) => {
            message.style.display = "none";
          });
      }

      dataFitPreference = maleJsonData.filter(
        (item) => item["Fit Preference"] === inputFitPreference
      );
    }, 500);
  }
  selectFootwear("Sneakers");
}
function selectFootwear(inputFootewear) {
  dataFootwear = dataFitPreference.filter(
    (item) => item["Footwear"] === inputFootewear
  );
  selectStretchPreference("No Stretch");
}
function selectStretchPreference(inputStretchPreference) {
  dataStretchPreference = dataFootwear.filter(
    (item) => item["Stretch Preference"] === inputStretchPreference
  );
  selectStylePersona("Classic cool");
}
function selectStylePersona(inputStylePersona) {
  dataStylePersona = dataStretchPreference.filter(
    (item) => item["Style Persona"] === inputStylePersona
  );
}
document.addEventListener("DOMContentLoaded", function () {
  const sliderWrappers = document.querySelectorAll(".slider-container");
  sliderWrappers.forEach((wrapper, index) => {
    const slider = wrapper.querySelector(".sliderranger");
    const track = wrapper.querySelector(".slider-track");
    const valueLabels = wrapper.querySelectorAll(".value-label");
    const selectedValueDisplay = wrapper.querySelector(".selected-value");
    if (!selectedValueDisplay) {
      const newSelectedValueDisplay = document.createElement("div");
      newSelectedValueDisplay.className = "selected-value";
      wrapper.appendChild(newSelectedValueDisplay);
      wrapper.selectedValueDisplay = newSelectedValueDisplay;
    }
    const dataValues = ["Loose", "Comfy", "Snug", "Fitted", "Second Skin"];
    function updateTrack() {
      const percentage = (slider.value / slider.max) * 100;
      track.style.background = `linear-gradient(to right, #d0021b ${percentage}%, #ccc ${percentage}%)`;
      valueLabels.forEach((label) => {
        if (parseInt(label.dataset.value) === parseInt(slider.value)) {
          label.classList.add("active");
        } else {
          label.classList.remove("active");
        }
      });
      const displayElement =
        selectedValueDisplay || wrapper.selectedValueDisplay;
      if (displayElement) {
        const sliderValue = parseInt(slider.value);
        displayElement.textContent = dataValues[sliderValue] || "";
        selectFitPreference(dataValues[sliderValue]);
      }
    }
    slider.addEventListener("input", updateTrack);
    valueLabels.forEach((label) => {
      label.addEventListener("click", () => {
        slider.value = label.dataset.value;
        updateTrack();
      });
    });
    updateTrack(); // Init
  });
  const strechsliderWrappers = document.querySelectorAll(
    ".strechslider-container"
  );
  strechsliderWrappers.forEach((wrapper, index) => {
    const strechslider = wrapper.querySelector(".strechsliderranger");
    const strechtrack = wrapper.querySelector(".strechslider-track");
    const strechvalueLabels = wrapper.querySelectorAll(".strechvalue-label");
    let strechselectedValueDisplay = wrapper.querySelector(
      ".strechselected-value"
    );
    if (!strechselectedValueDisplay) {
      const newDisplay = document.createElement("div");
      newDisplay.className = "strechselected-value"; // fix class name here
      wrapper.appendChild(newDisplay);
      strechselectedValueDisplay = newDisplay;
    }
    const strechdataValues = ["No Stretch", "Stretch"];
    function strechupdateTrack() {
      const strechpercentage = (strechslider.value / strechslider.max) * 100;
      strechtrack.style.background = `linear-gradient(to right, #d0021b ${strechpercentage}%, #ccc ${strechpercentage}%)`;
      strechvalueLabels.forEach((label) => {
        if (parseInt(label.dataset.value) === parseInt(strechslider.value)) {
          label.classList.add("active");
        } else {
          label.classList.remove("active");
        }
      });
      if (strechselectedValueDisplay) {
        const valueIndex = parseInt(strechslider.value);
        strechselectedValueDisplay.textContent =
          strechdataValues[valueIndex] || "";
        selectStretchPreference(strechdataValues[valueIndex]); // custom function
      }
    }
    strechslider.addEventListener("input", strechupdateTrack);
    strechvalueLabels.forEach((label) => {
      label.addEventListener("click", () => {
        strechslider.value = label.dataset.value;
        strechupdateTrack();
      });
    });
    strechupdateTrack(); // Initialize
  });
});
function showScreen(screenNumber, imgSrc) {
  document.querySelectorAll(".screen").forEach((screen) => {
    screen.style.display = "none";
  });
  if (imgSrc) {
    document.querySelector("#screen3 .fitimg").src = imgSrc;
  }
  document.getElementById("screen" + screenNumber).style.display = "flex";
  if (screenNumber === 7) {
    setTimeout(function () {
      displayProducts();
    }, 1000);
  }
}
document.querySelectorAll(".mood-option").forEach((option) => {
  option.addEventListener("click", function () {
    document.querySelectorAll(".heart-icon").forEach((icon) => {
      icon.classList.remove("heart-active");
    });
    this.querySelector(".heart-icon").classList.add("heart-active");
  });
});
function displayProducts() {
  const firstProduct = dataStylePersona[0];
  const keys = ["FITS1", "FITS2", "FITS3"];
  let html = "";

  const seen = new Set();
  
  if (firstProduct) {
    keys.forEach((key) => {
      let value = String(firstProduct[key] || "").trim();
      let description = String(firstProduct["Description"]).trim();
      if (
        !value ||
        value.toUpperCase() === "N/A" ||
        value.toUpperCase() === "NA" ||
        seen.has(value)
      ) {
        return;
      }

      seen.add(value); 

      const productSlug = value.replace(/ /g, "_");
      const encodedQuery = encodeURIComponent(value);
      const wordLimit = 15;
      const words = value.split(" ");
      const truncatedValue = words.length > wordLimit
        ? words.slice(0, wordLimit).join(" ") + "..."
        : value;
      
      html += `
        <div class="product-card">
          <img src="https://cdn.shopify.com/s/files/1/0805/5128/0930/files/${productSlug}.png?v=1746553551" alt="${value}">
          <div class="product-title">${truncatedValue}</div>
          <div class="product-desc">${description}</div>
          <a href="https://levi.in/pages/searchtap-search?q=${encodedQuery}&f.Gender=${gender}" class="add-to-cart">View Products</a>
        </div>`;
    });
  }

  document.getElementById("suggested-container").innerHTML =
    html ||
    `
    The combination of selection you have made is not available in any of the styles we have. 
    Please choose a different fit, style or stretch.
  `;
}

function showScreenmale(n) {
  document
    .querySelectorAll(".screen")
    .forEach((s) => (s.style.display = "none"));
  document.getElementById("screenmale" + n).style.display = "block";
}
function showScreenfemale(n) {
  document
    .querySelectorAll(".screen")
    .forEach((s) => (s.style.display = "none"));
  document.getElementById("screenfemale" + n).style.display = "block";
}
function startPage() {
  window.location.reload();
}
function copyLink(element) {
  const tooltip = document.querySelector(".tooltip");
  tooltip.textContent = "Link Copied";
  setTimeout(() => {
    tooltip.textContent = "Click to copy";
  }, 3000);
  const link = window.location.href;
  navigator.clipboard.writeText(link).then(() => {
    element.classList.add("clicked");
    setTimeout(() => {
      element.classList.remove("clicked");
    }, 2000);
  });
}
window.addEventListener("pageshow", function (event) {
  var historyTraversal =
    event.persisted ||
    (typeof window.performance != "undefined" &&
      window.performance.navigation.type === 2);
  if (historyTraversal) {
    window.location.reload();
  }
});
